import React from 'react';
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import TabbedPage from '../components/TabbedPage';
import SalaryStructures from '../components/LeaveAttendanceComps/PayrollComps/SalaryStructures';
import ComplianceSettings from '../components/LeaveAttendanceComps/PayrollComps/ComplianceSettings';

const TABS = [
    { key: 'structures', label: 'Salary Structures', icon: RequestQuoteRoundedIcon, module: 'salary-structures', render: () => <SalaryStructures /> },
    { key: 'statutory', label: 'Statutory Deductions', icon: VerifiedUserRoundedIcon, module: 'statutory-deductions', render: () => <ComplianceSettings /> },
];

export default function PayrollSetupPage() {
    return <TabbedPage tabs={TABS} />;
}
